
export default class FundChangeNameRequestModel {
    public fundName: string = '';
}
